
export { select } from "/vercel/path0/styled-system/recipes/select.mjs"